import { useEffect, useReducer } from "react";
import { Session } from "./Components/Session/Session";
import { GitHubFooter } from "./Components/GitHubFooter";
import { SessionType } from "./Components/Session/Types";
import { Reset, SaveSessions } from "./Storage/LocalStorage";
import { SessionList } from "./Components/SessionList";
import { initialState, reducer, stateContext } from "./state";
import twitterIcon from "./assets/twitter.svg";
import { ActiveSession } from "./Components/ActiveSession";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => SaveSessions(state.sessions), [state]);

  const handleCreateNewSession = () => {
    const newSession: SessionType = {
      id: Date.now(),
      name: "New Session",
      tasks: [],
      active: false,
    };
    dispatch({ type: "CREATE_SESSION", payload: { session: newSession } });
    dispatch({ type: "SELECT_SESSION", payload: { sessionId: newSession.id } });
  };

  const handleClearSessions = () => {
    Reset();
    dispatch({ type: "CLEAR_SESSIONS" });
  };

  const Provider = stateContext.Provider;

  const isActive = state.sessions.filter((session) => session.active === true);

  // Used an effect hook to update taskRefs when the tasks change.
  return (
    <Provider value={[state, dispatch]}>
      <div className="flex flex-col min-h-screen bg-gray-100">
        <main className="p-4 mt-10 flex-grow">
          <DndProvider backend={HTML5Backend}>
            {isActive.length === 0 ? (
              <div>
                <div className="absolute w-64 top-3/6 overflow-x-auto whitespace-nowrap transorm translate-x-1/4">
                  <SessionList />
                  <div className="mt-2">
                    <button
                      className="w-1/3 max-w-1/3 p-2 m-2 bg-gray-200 text-black-200 rounded shadow"
                      onClick={handleCreateNewSession}
                    >
                      New
                    </button>
                    <button
                      className="w-1/3 max-w-1/3 p-2 m-2 bg-gray-200 text-black-200 rounded shadow"
                      onClick={handleClearSessions}
                    >
                      Clear
                    </button>
                  </div>
                </div>
                <div className="absolute top-3/6 left-1/2 transform -translate-x-1/2 rounded-sm/2">
                  <div className="w-full">{<Session />}</div>
                </div>
              </div>
            ) : (
              <div className="flex items-center flex-col justify-center h-full">
                <ActiveSession />
              </div>
            )}
          </DndProvider>
        </main>

        <footer className="p-4 ">
          <div className="container mx-auto text-center text-gray-700 text-opacity-60 flex items-center justify-center">
            <a
              href="https://twitter.com/eleijonmarck"
              target="_blank"
              rel="noopener noreferrer"
              className="mr-2"
            >
              <img src={twitterIcon} alt="Twitter" className="w-4 h-4" />
            </a>
            <p>Made by @eleijonmarck</p>
          </div>
          <GitHubFooter />
        </footer>
      </div>
    </Provider>
  );
}

export default App;
